import {Language} from "../../constants/language";
import {School} from "../../models/school/school";
import {PaginatedResult, PAGINATION, PaginationUtil} from "../../utils/pagination-util";
import {
	SNL_MEDIA_EN, SNL_MEDIA_AR
} from "./school-media-data";
import {KASR_EL_DOBARA_EN, KASR_EL_DOBARA_AR } from "../address/addresses-data";
import {Currency} from "../../constants/currency";
import { CONTACT_EN } from "../../models/contact/contact";

const SCHOOLS_MOCK_DATA_EN: School[] = [
  {
    id: 1,
    key: "snl",
    title: "Super Natural Life Style (SNL)",
    description: "A 1-Year school focused on empowering believers to walk in a supernatural identity and serve with boldness and purpose.",
    shortDescription: "1-Year intensive program for supernatural lifestyle and ministry training.",
    longDescription: "The Super Natural Life Style (SNL) school is an intensive 1-Year program designed to transform believers into supernatural ambassadors of the Kingdom of God. This comprehensive school combines deep biblical teaching with practical training in supernatural ministry, equipping students to operate in divine authority and supernatural gifting. Students will learn to walk in their supernatural identity, move in the gifts of the Spirit, and minister with power and authority. The program includes extensive training in healing ministry, prophetic operation, deliverance, and supernatural evangelism. Through a combination of classroom instruction, practical workshops, and hands-on ministry experience, students develop confidence in their calling and ability to impact their communities with the power of God.",
    duration: "1 Year",
    address: KASR_EL_DOBARA_EN,
    languageSupport: ["English", "Arabic"],
    enrollmentStatus: "open",
    startDate: "February 01, 2026",
    endDate: "February 01, 2027",
    media: SNL_MEDIA_EN,
    category: "Ministry Training",
    time: "Weekly 10:00 AM - 4:00 PM",
    notes: "Intensive 1-Year program. Accommodation and meals included. Certificate of completion provided.",
    curriculum: [
      "Supernatural Identity and Authority",
      "Healing Ministry and Miracles",
      "Prophetic Ministry and Operation",
      "Supernatural Evangelism",
      "Leadership in the Supernatural",
      "Marketplace Ministry",
      "Intercession and Prayer",
      "Character Development and Holiness",
      "Team Ministry and Deployment"
    ],
    prerequisites: [
      "Born-again believer with personal relationship with Jesus Christ",
      "Basic understanding of Christian faith and biblical foundations",
      "Heart for ministry and serving God",
      "Willingness to be stretched and challenged",
    ],
    benefits: [
      "Deep understanding of supernatural lifestyle",
      "Practical ministry skills and confidence",
      "Personal breakthrough and healing",
      "Network of like-minded believers",
      "Certificate of completion",
      "Ongoing mentorship opportunities",
      "Ministry deployment and assignment",
      "Spiritual gifts activation and development"
    ],
    instructors: [],
    tuition: {
      amount: 6000,
      currency: Currency.EGP,
      installments: true
    },
    capacity: 100,
    enrolled: 32,
    testimonials: [],
    enrollmentForm: "https://docs.google.com/forms/d/e/1FAIpQLSdVkYfMbEJTFgkUDIgc7dxvS_Spq3ahbzBIMnTfe91pSCNKpw/viewform?usp=header",
    contactInfo: CONTACT_EN
  }
];

const SCHOOLS_MOCK_DATA_AR: School[] = [
  {
    id: 1,
    key: "snl",
    title: "مدرسة نمط الحياة الفائق الطبيعة (SNL)",
    description: "مدرسة مكثفة لمدة سنة تركز على تمكين المؤمنين للسير في هوية فائقة الطبيعة والخدمة بجرأة وهدف.",
    shortDescription: "برنامج مكثف لمدة سنة لتدريب نمط الحياة الفائق الطبيعة والخدمة.",
    longDescription: "مدرسة نمط الحياة الفائق الطبيعة (SNL) هي برنامج مكثف لمدة 1 سنة مصمم لتحويل المؤمنين إلى سفراء فائقي الطبيعة لملكوت الله. هذه المدرسة الشاملة تجمع بين التعليم الكتابي العميق والتدريب العملي في الخدمة الفائقة الطبيعة، لتجهيز الطلاب للعمل في السلطة الإلهية والموهبة الفائقة الطبيعة. سيتعلم الطلاب السير في هويتهم الفائقة الطبيعة، والتحرك في مواهب الروح، والخدمة بقوة وسلطان. يشمل البرنامج تدريباً واسعاً في خدمة الشفاء، والعمل النبوي، والتحرير، والكرازة الفائقة الطبيعة.",
    duration: "1 سنة",
    address: KASR_EL_DOBARA_AR,
    languageSupport: ["الإنجليزية", "العربية"],
    enrollmentStatus: "open",
    startDate: "01 فبراير 2026",
    endDate: "01 فبراير 2026",
    media: SNL_MEDIA_AR,
    category: "تدريب الخدمة",
    time: "ااسبوعيا 10:00 صباحاً - 4:00 مساءً",
    notes: "برنامج مكثف لمدة سنه. يشمل السكن والوجبات. يتم تقديم شهادة إتمام.",
    curriculum: [
      "الهوية والسلطان الفائق الطبيعة",
      "خدمة الشفاء والمعجزات",
      "الخدمة والعمل النبوي",
      "التحرير والحرب الروحية",
      "الكرازة الفائقة الطبيعة",
      "القيادة في الفائق الطبيعة",
      "خدمة السوق",
      "الشفاعة والصلاة",
      "تطوير الشخصية والقداسة"
    ],
    prerequisites: [
      "مؤمن مولود ثانية مع علاقة شخصية مع يسوع المسيح",
      "فهم أساسي للإيمان المسيحي والأسس الكتابية",
      "قلب للخدمة وخدمة الله",
      "الاستعداد للتمدد والتحدي"
    ],
    benefits: [
      "فهم عميق لنمط الحياة الفائق الطبيعة",
      "مهارات الخدمة العملية والثقة",
      "الاختراق والشفاء الشخصي",
      "شبكة من المؤمنين ذوي التفكير المماثل",
      "شهادة إتمام",
      "فرص الإرشاد المستمر",
      "نشر وتكليف الخدمة",
      "تفعيل وتطوير المواهب الروحية"
    ],
    instructors: [],
    tuition: {
      amount: 6000,
      currency: Currency.EGP,
      installments: true
    },
    capacity: 100,
    enrolled: 32,
    testimonials: [],
    enrollmentForm: "https://docs.google.com/forms/d/e/1FAIpQLSdVkYfMbEJTFgkUDIgc7dxvS_Spq3ahbzBIMnTfe91pSCNKpw/viewform?usp=header",
    contactInfo: CONTACT_EN
  }
];

export const getSchoolsLocalized = (
  language: Language = Language.AR,
  fetchAll: boolean = false,
  page: number = PAGINATION.DEFAULT_PAGE,
  limit: number = PAGINATION.DEFAULT_PAGE_SIZE
): PaginatedResult<School> => {
  const schools = language === Language.AR ? SCHOOLS_MOCK_DATA_AR : SCHOOLS_MOCK_DATA_EN;
  const actualLimit = fetchAll ? -1 : limit;
  return PaginationUtil.paginate<School>(schools, page, actualLimit);
};

export { SCHOOLS_MOCK_DATA_EN, SCHOOLS_MOCK_DATA_AR };